import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    carItems: [],
    chosenItem: {},
    carNumber: ''
  },
  getters: {
    carItems: state => state.carItems,
    chosenItem: state => state.chosenItem,
    carNumber: state => state.carNumber,
  },
  mutations: {
    addCarItems(state, payload) {
      state.carItems = payload.carItems;
    },
    addChosenItem(state, payload) {
      state.chosenItem = payload.chosenItem;
    },
    addCarNumber(state, payload) {
      state.carNumber = payload.carNumber;
    }
  }
});